

 
<template>
     
        <Select v-model="m_Value"
                 :value="m_Value"
                v-show="FinalVisible"
                :disabled="FinalEnabled == false"
                :nullable="(!FinalRequired)+''"
                :Key="Key"
                @change="OnValueChange"
                ref="Element">
            <option :value="null">請選擇</option>


            <option v-for="option in m_Attribute.Options"
                    :disabled="option.Value=='_Disabled_'"
                    v-if="ExcludeOptionValue == null || (option.Value+'') != (ExcludeOptionValue+'')"
                    v-bind:value="option.Value">
                {{ option.Text }}
            </option>
        </Select>
     





</template>

<script scoped>
    import Utility from '@/Common/Utility'
    import FieldOptionService from '@/Common/FieldOptionService'
    import TControlBase from '@/Common/TControlBase';
 
    export default {
        name: "t-select",
        data() {
            return {
                m_Value: null,
                Key:1,
                ExtendOption: false,

                m_Attribute: TControlBase.Attribute({
                  
                })
            }
        }
        ,

        
        //props2: ["value", "nullable", "Name", "Attribute", "DataType", "OptionName",
        //    "ComplexOptionName",
        //    "CacheOption" ,
        //    "Options", "Keep", "KeyName", "TriggerChange", "Enabled", "ExcludeOptionValue"],

        props: [...TControlBase.BaseProps] ,

        computed: {

            //AllOptions: function () {
            //    let options = [];

            //    if (this.Attribute != null && this.Attribute.Options != null) {
            //        options = this.Attribute.Options;
            //    }
            //    else if (this.m_Attribute.Options.length > 0) {
            //        options.push(...this.m_Attribute.Options);
            //    }


            //    return options;
            //},
  
            //CssClass: function () {
            //    let result = "";


            //    if (this.m_Attribute != null && this.m_Attribute.CssClass != null) {
            //        result = this.m_Attribute.CssClass;
            //    }

            //    return result;
            //}
            
        }
        ,

        methods: {

            OnValueChange(e) {
                this.DoOnValueChange(e);

            },

            UpdateElementByAttribute() {

            },

            ResetValue() {

              
                if (this.m_Value != null && this.m_Value != "") {
                    let optionElements;

                    if (this.$refs != null && this.$refs.Element != null) {
                        this.$refs.Element.value = this.m_Value;

                        this.$forceUpdate();
                    }
                }
                else {
                    if (this.Name == "ReactionArticleStatus") {
                        debugger;
                    }
                }

                 
            },

            //GetValue() {
            //    return this.$el.value;
            //},

            //SetValue(value, triggerChange) {
            //    this.m_Value = value;

            //    if (this.$refs != null && this.$refs.Element != null) {
            //        this.$refs.Element.value = value;

            //        this.$emit("input", value);

            //        if (triggerChange == null || triggerChange == true) {

            //            this.$emit("change", value);
            //        }
            //    }
            //},

            CheckExtendOption() {
                let optionElements;
                let found = false;
                let i;


                optionElements = this.$refs.Element.querySelectorAll(":scope OPTION");

                for (i = 0; i < optionElements.length; i++) {
                    if (optionElements[i].value == this.m_Value) {
                        found = true;
                        break;
                    }
                }

                if (found) {
                    this.ExtendOption = false;
                }
                else {
                    this.ExtendOption = true;
                }

                if (this.ExtendOption) {
                    this.m_Attribute.Options.push(
                        {
                            Value: this.m_Value,
                            Text: this.m_Value
                        }
                    );

                    setTimeout(
                        function () {
                            if (this.$refs != null && this.$refs.Element != null) {
                                this.$refs.Element.value = this.m_Value;
                            }
                        }.bind(this),
                        100
                    );
                   

                    this.$forceUpdate();
                }
            } ,
        },

 
        beforeMounted() {

        },

        mounted() {
            this.DoOnMounted();
        } ,
        
        created() {
 
             
            TControlBase.call(this);



            //if (this.nullable == "false" || this.nullable == false) {
            //    this.m_Attribute.Nullable = false;
            //}
            //else {
            //    this.m_Attribute.Nullable = true;
            //}


            //if (this.DataType != null) {
            //    this.m_Attribute.DataType = this.DataType;
            //}

            //if (this.Attribute != null) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            //}

            //if (this.Options != null) {
            //     this.m_Attribute.Options = this.Options;
            //}

            //if (this.OptionName != null) {
            //    let dataLangauge;

            //    if (window.location.href.indexOf("Backend") > 0) {
            //        dataLangauge = Utility.GetBag("BackendDataLanguage");
            //    }
            //    else {
            //        dataLangauge = Utility.GetBag("DataLanguage");
            //    }
            //}

 
            //if (this.value != null) {
 
            //    this.SelectedValue = this.value;

            //    setTimeout(
            //        function () {
            //            this.ResetValue();

            //            //this.CheckExtendOption();
            //        }.bind(this),
            //        100
            //    );
               
            //    this.$forceUpdate();

            //}


            //if (this.Keep == "true" || this.Keep == true) {
            //    this.LoadValue().then(
            //        function (result) {
            //            if (this.TriggerChange == true || this.TriggerChange == "true") {
            //                this.$emit("change");
            //            }
            //        }.bind(this)
            //    );
            //}
      

            //this.UpdateElementByAttribute();
        },

 

        //watch:  {


        //    value: function (newVal, oldVal) {

        //        this.DoOnWatchValueChange(newVal, oldVal);

        //        //this.SelectedValue = newVal;
        //        //this.$refs.Element.value = newVal;
                
        //        //setTimeout(
        //        //    function () {
        //        //        this.SelectedValue = newVal;
        //        //        this.$refs.Element.value = newVal;

        //        //        if (this.Keep == "true" || this.Keep == true) {
        //        //            this.StoreValue();
        //        //        }
                         

        //        //        if (newVal != null) {
 
        //        //            this.SelectedValue = newVal;

        //        //            setTimeout(
        //        //                function () {
        //        //                    //this.CheckExtendOption();
        //        //                }.bind(this),
        //        //                100
        //        //            );

        //        //            this.$forceUpdate();

        //        //        }
        //        //    }.bind(this),
        //        //    100
        //        //);


        //        //this.ClearError();
        //    },

        //    nullable: function (newVal, oldVal) {
        //        //this.m_Attribute.Nullable = newVal;
        //        this.DoOnWatchPropertyChange("Nullable", newVal, oldVal);
        //    },

        //    Required: function (newVal, oldVal) {
        //        //this.m_Attribute.Nullable = newVal;
        //        this.DoOnWatchPropertyChange("Required", newVal, oldVal);
        //    },

        //    Attribute: function (newVal, oldVal) {

        //        this.DoOnWatchAttributeChange(newVal, oldVal);
        //        //Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);

        //        //if (this.nullable != null) {
        //        //    if (this.nullable == false || this.nullable == "false") {
        //        //        this.m_Attribute.Nullable = false;
        //        //    }
        //        //}

        //        //this.$forceUpdate();

        //        //if (this.SelectedValue != null && this.SelectedValue != '') {
        //        //    setTimeout(
        //        //        () => {
        //        //            this.$refs.Element.value = this.SelectedValue;
        //        //        },
        //        //        10
        //        //    );
        //        //}
                 
        //    },

        //    Options: function (newVal, oldVal) {

        //        this.DoOnWatchPropertyChange("Options", newVal, oldVal);
        //    //    if (newVal != null) {
        //    //        this.m_Attribute.Options = newVal;
        //    //    }
        //    //    else {
        //    //        this.m_Attribute.Options = [];
        //    //    }

        //    //    Utility.TouchArray(this.m_Attribute.Options);

        //    //    this.$forceUpdate();
        //    },

 
        //}
        


    }
</script>

<style>
      
    select:required:invalid {
        color: lightgray;
      }

      option[disabled] {
      }

      option {
        color: #000;
      }
</style>
